// extracted by mini-css-extract-plugin
module.exports = {"imageBlockInjection":"ImageBlock_imageBlockInjection__3jWXe"};